import { render, staticRenderFns } from "./pc-generate-share.vue?vue&type=template&id=17562b1a&scoped=true"
import script from "./pc-generate-share.vue?vue&type=script&lang=js"
export * from "./pc-generate-share.vue?vue&type=script&lang=js"
import style0 from "./pc-generate-share.vue?vue&type=style&index=0&id=17562b1a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17562b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17562b1a')) {
      api.createRecord('17562b1a', component.options)
    } else {
      api.reload('17562b1a', component.options)
    }
    module.hot.accept("./pc-generate-share.vue?vue&type=template&id=17562b1a&scoped=true", function () {
      api.rerender('17562b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/share/pc-generate-share.vue"
export default component.exports